/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

export default [
  {
    name: 'weather-fish',
    path: 'weather',
    redirect: { name: routeNames.WEATHER_OVERVIEW_FISH },
    component: () => import('@/components/weather/weather-card'),
    children: [
      {
        name: routeNames.WEATHER_OVERVIEW_FISH,
        path: 'overview',
        component: () => import('@/components/weather/weather-overview-tab'),
      },
      {
        name: routeNames.WEEKLY_WEATHER_FISH,
        path: 'weekly-forecast',
        component: () => import('@/components/weather/weather-weekly-forecast'),
      },
      {
        name: routeNames.HOURLY_WEATHER_FISH,
        path: 'hourly-forecast',
        component: () => import('@/components/weather/weather-hourly-forecast'),
      },
      {
        name: routeNames.MOON_WEATHER_FISH,
        path: 'moon-forecast',
        component: () => import('@/components/weather/weather-moon-forecast'),
      },
    ],
  },
]
